export default {
  allinone: {
    bannerTitle: 'All-in-one solution',
    title: 'Software and hardware integration solution',
    info:`
    In addition to providing PWmat software licenses, Longxun Kuangteng also provides all-in-one machines
    pre-installed with Longxun Kuangteng's various software products,
    providing an integrated solution combining software and hardware,
    including the intelligent computing CPU all-in-one machine QStation,
    the stand-alone version Mstation and the cluster version Mcluster. All are equipped with PWmat, Q-Flow, Q-Studio, PWkit,
    as well as machine management and job scheduling software, and users can use them out of the box.
    At the same time, Longxun Kuangteng has built its own supercomputing cloud Mcloud, providing machine time rental services.
    Users can use Longxun's various software products when they directly rent machines.
    `,

    qstationT: 'Atomic scale material intelligent computing all-in-one machine',
    qstationInfo:`
    QStation is a revolutionary all-in-one CPU machine designed for cutting-edge materials science research.
    It seamlessly integrates complex atomic-scale modeling with high-performance simulation computing.
    It is a workstation that can be used by experimental groups and computing novices,
    opening up a new dimension for you to explore the microscopic world of materials.
    QStation is equipped with precise modeling functions, which can easily build a variety of atomic models from small molecules,
    perfect crystals to nanotubes, clusters and even quantum transport devices; the intelligent
    combination mode can realize fast and accurate model generation functions,
    helping you to freely design key scientific research models such as interface structure,
    surface adsorption system, disordered structure, single atom catalytic system, etc.; at the same time,
    the intelligent optimization function has integrated the most cutting-edge machine learning force field,
    giving the model a configuration and energy state that is closer to real physics;
    the intelligent calculation workflow can be started with one click.
    According to the model parameters you carefully constructed, QStation can intelligently generate the most
    optimized calculation settings and efficient workflows, greatly simplifying the tedious configuration process;
    QStation can deeply explore the core physical properties of materials such as
    electronic structure, optical response, transport behavior, mechanical strength and thermal properties,
    and reveal the essential laws of materials; professional calculation result post-processing can convert data
    into clear and intuitive charts, maps and key data, making scientific research results vivid.
    `,
    qstationT2: 'The following table shows the hardware configuration of Qstation',

    mstationT: 'Standalone',
    mstationInfo:`
    The stand-alone version of Mstation is a dual-channel 4U server,
    including two CPUs (14x2=28 cores) and four GPU cards. It is also pre-installed with PWmat,
    Q-Flow, Q-Studio and PWkit software, and can also install various open source software according to user needs.
    Two stand-alone versions of Mstation can be directly connected through ib network cables to form a lightweight cluster.
    Compared with the cluster version of Mcluster,
    it does not require management nodes and inifiniband switches and other equipment,
    has the characteristics of high cost performance, and can perform large-scale system calculations.
    `,
    mstationT2: 'The following table shows the hardware configuration of Mstation and the dual-machine interconnected version of Mstation',
    mstationT2R0C1: 'hardware',
    mstationT2R0C2: 'Standalone Mstation',
    mstationT2R0C3: 'Dual-machine interconnected version of Mstation',
    mstationT2R1C2: 'Two CPUs (14x2=28 cores)',
    mstationT2R1C3: 'Two CPUs per machine (14x2x2=56)',
    mstationT2R2C2: '4 NVIDIA ® GTX 3080Ti/3090',
    mstationT2R2C3: '8 NVIDIA ® GTX 3080Ti/3090',
    mstationT2R3C1: 'Memory',
    mstationT2R3C2: 'Up to 512GB DDR4',
    mstationT2R3C3: 'Up to 512GB DDR4',
    mstationT2R4C1: 'operating system',
    mstationT2R5C1: 'IB Switching Network',
    mstationT2R5C3: 'have',
    mcluster: 'Mcluster Cluster Edition',
    mclusterP1: `
      MCluster consists of multiple MStations, storage servers and a management node.
      Each MStation transmits data through an ultra-high-speed Infiniband network.
      Mcloud also pre-installs PWmat, Q-Flow, Q-Studio and PWkit software,
      as well as cluster management software XCAT and job scheduling software slurm.
      After deploying PWmat, "MCluster" is widely used in the field of material computing.
      The most typical application is material genome computing,
      which is of great help to material genome development, high-throughput computing,
      database construction and material search. The most successful case at present is the
      material database generated by the Shenzhen Graduate School of Peking University
      through the MCluster platform. With the help of Longxun,
      the Shenzhen Graduate School of Peking University established
      the world's first HSE (hybrid functional) material band database. Through the MCluster platform,
      more than one thousand crystal structure data can be generated for the database every week.
      The MCluster+PWmat platform plus the corresponding automated workflow framework
      make this system a rare and powerful tool for completing material genome projects.
    `,
    mclusterP2: `
      Another application of MCluster is the first-principles calculation of very large systems.
      We found that using 48 GPUs can calculate systems with up to 5000 atoms (more than 20,000 electrons),
      a typical example of which is a system of 5120 Si atoms. On "MCluster",
      such a system is self-consistent enough to converge in just 3 hours.
      To demonstrate the accuracy of PWmat for large system calculations,
      we calculated a bulk material system of 4096 Si atoms with a point defect (see figure),
      and calculated the wave functions of electrons in partially occupied states (open shells) near
      the Fermi surface in this defect system, as shown in Figure 2 below.
      In addition, we also performed a first-principles molecular dynamics simulation of a
      system of 1000 water molecules (3000 atoms, see figure): each molecular dynamics step took only 2.5 minutes.
      This speed is very encouraging, it is close to the simulation scale and speed of the atomic basis set method,
      but there is no need to worry about the errors caused by inaccurate basis sets.
      The above example is one of the largest plane wave system calculations to date.
      For example, in 2011, the Gordon Bell prize calculated a quantum wire of 10,000 Si atoms using real space methods.
      The n1, n2, n3 used were eight times smaller than our n1, n2, n3 of 5000 Si atoms.
      On the then largest Japanese supercomputer "K" in the world,
      it took 24 hours to complete a self-consistent calculation.
      Another example is the Gordon Bell prize in 2006,
      which used the plane wave program Qbox to calculate a 1000-atom molybdenum system with a total of 12,000 electrons.
      The entire BlueGene/L machine (the fastest computer in the world at the time, 65,536 nodes) was used.
      Each self-consistent calculation took about 220 seconds (estimated based on the fact that each SCF self-consistency
      step consists of 4 steepest decent steps).
      In contrast, our Mcluster+PWmat calculates a 3000-atom Si system with 12,000 electrons,
      and each self-consistent calculation takes only 100 seconds. For existing open source and
      commercial plane wave basis set simulation calculation software,
      it is not easy or even impossible to complete the calculation of such a super-large system.
      For example, on the well-known Guangzhou supercomputer "Tianhe-2", through repeated testing
      of the recognized strongest commercial plane wave calculation software,
      we found that no matter how many cores are used (up to several thousand cores),
      the system of 4000 Si atoms can never run, and can only run 2000 to 3000 Si atoms at most.
      Using 2000 CPUs to calculate this 2000 Si atom system, using the default settings,
      this software needs at least half an hour to complete the entire self-consistent calculation.
      But the same system and task, calculated on MCluster+PWmat, only takes a total of 8 minutes.
      See the table below for specific test data:
    `,
    mcloud: 'Supercomputing Cloud Mcloud',
    mcloudR0C1: 'Test system',
    mcloudR0C2: 'number of atoms',
    mcloudR0C3: 'Number of electrons',
    mcloudR0C4: 'Cut-off energy (eV)',
    mcloudR0C5: 'Pseudopotential',
    mcloudR0C6: 'Time (full convergence)',
    mcloudR1C6: '3 hours',
    mcloudR2C6: '1 hour',
    mcloudR3C6: '3 hours',
    mcloudR4C6: '22 minutes',
    mcloudR5C6: '42 minutes',
    mcloudR6C6: '7 minutes',
    mcloudR7C6: '16 minutes',
    mcloudR8C6: '150 seconds one-step MD',
    mcloudR9C6: '840 seconds one-step MD',
    mcloudP1: `
    Mcloud is a supercomputing cloud platform composed of high-performance clusters and cloud
    desktops built by Longxun Kuangteng. Version 2.0 was successfully launched on April 1, 2022.
    The cloud platform integrates software such as PWmat, Q-Flow, Q-Studio and Lammps,
    and provides SaaS material simulation calculation services. Users can complete the registration independently.
    After registration, they can use PWmat and other software online and rich GPU card time resources.
    Q-Flow is a PWmat visualization operation interface launched by Longxun Kuangteng.
    It visualizes the first-principles calculation and decomposes the functional modules
    of PWmat into different calculation units. Users can complete calculations of
    different properties by dragging these calculation units and connecting them into workflows.
    Q-Studio is an online modeling tool developed based on jsmol.
    Users do not need to install any software. They only need to open the browser
    to complete online modeling. The registration and login address of Mcloud is:
    `,
  }
}